import { Button, Drawer, Form, Input, Select, Space } from "antd";
import axios from "axios";
// import React, { useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import TextArea from "antd/es/input/TextArea";
import { useContext, useState } from "react";

const UpdateEmployeeSched = ({ open, close }) => {
  const { userData } = useContext(UserInfo);
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  //   console.log("userData.data.id: ", userData.data.id);

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) {
      alert("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("merchant_id", userData.data.id);

    try {
      const response = await axios.post(
        "user/merchant/update-or-create/employee-schedule",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("DATA: ", response.data);
      alert(response.data.message);
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("File upload failed. Please try again.");
    }
  };

  return (
    <Drawer
      title="Update Bulk Employee Schedule"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <form onSubmit={handleUpload}>
        <input
          id="file"
          name="file"
          type="file"
          accept=".csv"
          onChange={handleFileChange}
        />
        <button type="submit">Upload</button>
      </form>
    </Drawer>
  );
};

export default UpdateEmployeeSched;
